export default function StatsBanner() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="lg:w-5/12 text-center lg:text-left">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              Why Use<br />
              Superbuy<br />
              Spreadsheet
            </h2>
          </div>

          <div className="lg:w-7/12 flex flex-row items-center justify-center lg:justify-start gap-8 md:gap-14">
            <div className="text-center">
              <span className="block text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-secondary-500">
                1000+
              </span>
              <span className="block mt-2 text-xs md:text-sm text-foreground-500">
                Curated Products
              </span>
            </div>

            <div className="w-px h-16 md:h-20 bg-background-300"></div>

            <div className="text-center">
              <span className="block text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-secondary-500">
                50+
              </span>
              <span className="block mt-2 text-xs md:text-sm text-foreground-500">
                Premium Brands
              </span>
            </div>

            <div className="w-px h-16 md:h-20 bg-background-300"></div>

            <div className="text-center">
              <span className="block text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-secondary-500">
                Daily
              </span>
              <span className="block mt-2 text-xs md:text-sm text-foreground-500">
                Fresh Updates
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}